<template>
  <MarkupGenerator
    v-if="discountTextCart"
    :is-page="false"
    :page-data="{
      PageContent: discountTextCart,
    }"
  />
</template>

<script lang="ts" setup>
import type { MarkupData } from '~/repository/modules/category.module';
import type { BaseMarkupComponent } from '~/models/BaseMarkupComponent.model';
const bodyMarkup = ref<MarkupData | null>(null);

const store = useMyCheckoutStore();
defineProps<{ discountTextCart?: BaseMarkupComponent[] }>();
</script>

<style></style>
